import type { MouseEvent, ReactNode } from 'react';
import { Link } from '../../atoms/link/Link';
import * as styles from './ListItemLink.module.scss';

interface IListItemLinkProps {
    children: ReactNode;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    theme?: 'white' | 'secondary';
    to: string;
}

export function ListItemLink(props: IListItemLinkProps) {
    return (
        <li className={styles.listItem}>
            <Link
                linkColor={props.theme}
                onClick={props.onClick}
                to={props.to}
            >
                {props.children}
            </Link>
        </li>
    );
}
